module.exports = __webpack_public_path__ + "static/media/wd.dc291b9f.png";